import { render, staticRenderFns } from "./CustomerCreditCardItem.vue?vue&type=template&id=66058ede&scoped=true&"
import script from "./CustomerCreditCardItem.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditCardItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditCardItem.vue?vue&type=style&index=0&id=66058ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66058ede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
